import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import MicroModal from "micromodal";
import top from "./_top";
import common from "./_common";
import smoothScroll from "./_common/smooth-scroll";
import about from "./_about";
import works from "./_works";
import access from "./_access";
import contact from "./_contact";
import privacy from "./_privacy";

gsap.registerPlugin(ScrollTrigger);

MicroModal.init({
  // onShow: (modal) => console.info(`${modal.id} is shown`), // [1]
  // onClose: (modal) => console.info(`${modal.id} is hidden`), // [2]
  // openTrigger: "data-custom-open", // [3]
  // closeTrigger: "data-custom-close", // [4]
  openClass: "is-open", // [5]
  // disableScroll: true, // [6]
  // disableFocus: false, // [7]
  awaitOpenAnimation: true, // [8]
  awaitCloseAnimation: true, // [9]
  // debugMode: true, // [10]
});

smoothScroll();
top();
about();
works();
access();
contact();
privacy();
common();